import { render, staticRenderFns } from "./CompteCreationSalon.vue?vue&type=template&id=51776847&"
import script from "./CompteCreationSalon.vue?vue&type=script&lang=js&"
export * from "./CompteCreationSalon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports